import { DateInputProps, DetailsFormFieldProps, DisplayProps } from "models/propTypes/wintFormPropsTypes";
import DetailsFormBaseField from "./detailsFormBaseField";
import DateDisplay from "../formDisplays/dateDisplay";
import DateInput from "../formFields/dateInput";

const DateField = (props: DateInputProps & DisplayProps & DetailsFormFieldProps) => {
  return <DetailsFormBaseField<DateInputProps> Display={DateDisplay} Input={DateInput} {...props} />;
};

export default DateField;
